import * as angular from "angular";
import {IController, IScope} from "angular";

export class PaymentListItemCtrl implements IController {
  id: string;
  selected: any;
  onSelect: Function;
  public payment: any;

  constructor(private $scope: IScope, private $payment) {
  }

  $onInit() {
    this.$payment(this.id).$bindCtrl(this.$scope, this, 'payment');
    // $route($scope.id).$bindCtrl(this.$scope, this, 'route');
  }

}

angular
  .module('bringoz.admin.payments')
  .component('paymentListItem', {
    bindings: {
      id: '<',
      selected: '<?',
      onSelect: '&'
    },
    template: require('./payment-list-item.html').default,
    controller: PaymentListItemCtrl

  });
